import styled from '@emotion/styled';

const Section = styled.section`
	padding: 1.5rem;
	background: #f5f5f5;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

const Logo = styled.img`
	max-height: 2rem;
`;

export default function PoweredBlockZeta({ tenantLogo }: { tenantLogo: string }) {
	return (
		<Section>
			<span>Presented By</span>
			<Logo src={tenantLogo} alt="Tenant logo" />
		</Section>
	);
}
